import { useCaseTemplatesWithVersions } from "src/cases/queries/templates";
import { useMaxCaseTemplates } from "src/hooks/useMaxCaseTemplates";

/**
 * Reason why no further case template can be created, or `undefined` when one
 * can. Creating from scratch and copying an existing template both go through
 * the same endpoint and count against the same cap, so the reason gates the
 * whole Add template dropdown rather than a single option.
 */
export const useAddTemplateDisabledReason = (): string | undefined => {
  const maxTemplates = useMaxCaseTemplates();
  const { data: templates } = useCaseTemplatesWithVersions();

  return (templates?.length ?? 0) >= maxTemplates
    ? `You've reached the limit of ${maxTemplates} templates for this workspace.`
    : undefined;
};
